import $ from 'jquery';

const PO_BOX_RESTRICTED_VALIDATION_MODE = 'restrict_pobox';
const PO_BOX_DATA_KEY = 'rulePobox';
const PO_BOX_REGEX = /(([\w\s*\W] )?(P(OST|OSTAL)?\.?\s*((O(FF(ICE)?)?)?\.?\s*B(O|OX)?)+))( [\w\s*\W])?/i;

/**
 * Validates address string to not contain PO Box(Postal Office Box) pattern
 * Intended to be used with jQuery validate plugin, learn more:
 * https://jqueryvalidation.org/jQuery.validator.addMethod/#jQuery-validator-addMethod-name-method-message
 * @param value {String} - text value of the input field element
 * @param element {Node} - input DOM element to be validated
 * @returns {boolean} - returns true if text doesn't contain PO Box address in it, otherwise - false
 */
export const excludePoBox = (value, element) => {
    const validationMode = $(element).data(PO_BOX_DATA_KEY);
    // to disable this validation you have to replace value of data-rule-pobox attribute with different one
    if (validationMode !== PO_BOX_RESTRICTED_VALIDATION_MODE) return true;
    return !value || !PO_BOX_REGEX.test(value);
};
